<div class="send-dialog">
  <div class="ui-g-12 p-zero dialog-header m-0 d-flex align-items-center">
    <i class="far fa-paper-plane font-20 font-gray-45 header-icon"></i>
    <div class="send-dialog-heading">Send Inspection Report</div>
    <i class="far fa-times fa-sm dialog-close" (click)="close({})"></i>
  </div>

  <div class="ui-g-12 dialog-body pt-3" #sendDialog>
    <div class="row m-0 p-0">
      <!-- Start Left Panel -->
      <div class="col-12 col-lg-6 p-0">
        <div class="left-box pt-2">
          <div class="input-style-wrapper-icon w-100">
            <div class="icon-wrapper align-self-center font-14">
              <i class="far fa-user font-gray-35"></i>
            </div>

            <div class="input-wrapper small p-relative">
              <app-input placeholder="Customer*" id="objective" [disabled]="true" [value]="customer.displayName"
                theme="light" [floatingLabel]="true"> </app-input>
              <div class="globe-icon" (click)="switchLanguage()" *ngIf="companyLocalization">
                {{currentLang?.toUpperCase()}}
                <i class="fa fa-globe fa-globe" aria-hidden="true"></i>
              </div>
            </div>
          </div>

          <div class="input-style-wrapper-icon w-100 mt-30">
            <div class="icon-wrapper align-self-center font-14">
              <i class="far fa-link font-gray-35"></i>
            </div>

            <div class="input-wrapper small">
              <app-input placeholder="Subject" id="subject" (appChange)="subjectChange($event)" [disabled]="false"
                [value]="subject" theme="light" [floatingLabel]="true"> </app-input>
            </div>
          </div>

          <div class="input-style-wrapper-icon w-100 mt-30 full-height-textarea">
            <div class="icon-wrapper align-self-start font-14 mt-2">
              <i class="far fa-file-alt font-gray-35"></i>
            </div>

            <div class="input-wrapper small">
              <span class="fake-small-label">
                Message
              </span>
              <textarea [(ngModel)]="content" id="content" name="content" placeholder="" rows="5" [value]="content"
                cols="30" class="primary-theme"> </textarea>
            </div>
          </div>
        </div>
      </div>
      <!-- End Left Panel -->

      <!-- Start Right Panel -->
      <div class="col-12 col-lg-6 p-0">
        <div class="right-box flex-column pt-0 pr-0">
          <!-- Contact preferrence -->
          <div class="contact-btn d-flex pr-0">
            <app-outline-icon-btn id="send-dialog-email" class="mr-2" label="Email" icon="far fa-envelope"
              [active]="isEmailSelected" (handleClick)="toggleActiveState('isEmailSelected', $event)">
            </app-outline-icon-btn>

            <app-outline-icon-btn id="send-dialog-phone" label="SMS" icon="far fa-mobile" [active]="isSMSSelected"
              (handleClick)="toggleActiveState('isSMSSelected', $event)"> </app-outline-icon-btn>
          </div>

          <!-- Notification -->
          <div class="notification-contact-box flex-column flex-center-start mt-2 position-relative"
            tooltipStyleClass="ticket-tooltip modifier apt-tooltip completed" tooltipPosition="right"
            [pTooltip]="notificationRecipientTooltip" [escape]="false">
            <i class="far fa-edit pointer p-2 update-recipient-icon" tooltipPosition="top"
              [ngClass]="{ 'not-allowed': !isEmailSelected && !isSMSSelected }"
              [pTooltip]="!isEmailSelected && !isSMSSelected ? 'Select Email or Phone to add Recipients' : ''"
              (click)="openUpdateRecipientDialog('confirmation')"></i>

            <div class="width-100p flex-start-center font-13">
              <i class="far fa-bell font-gray-85 contact-icon flex-center-center"></i>
              <span class="font-bold">Notification</span>
            </div>

            <div class="flex-start-center font-12">
              <i class="far fa-envelope font-gray-85 contact-icon flex-center-center"></i>
              <span *ngIf="recipients?.emails?.length === 1">
                {{ (recipients?.emails)[0].value }}
              </span>

              <span *ngIf="recipients?.emails?.length !== 1">
                <span *ngIf="!recipients?.emails?.length">No email</span>
                <span *ngIf="recipients?.emails?.length">{{ recipients?.emails?.length }} email addresses</span>
              </span>
            </div>

            <div class="flex-start-center font-12">
              <i class="far fa-mobile font-gray-85 contact-icon flex-center-center"></i>
              <span *ngIf="recipients?.phones?.length === 1">
                {{ (recipients?.phones)[0].value | mask: '(000) 000-0000' }}
              </span>

              <span *ngIf="recipients?.phones?.length !== 1">
                <span *ngIf="!recipients?.phones?.length">No phone</span>
                <span *ngIf="recipients?.phones?.length">{{ recipients?.phones?.length }} mobile numbers</span>
              </span>
            </div>
          </div>

          <!-- Inspections -->
          <div class="notification-contact-box flex-column mt-2">
            <div class="flex-start-center pointer" (click)="toggleInspectionVisibilty()">
              <i class="inspection-dropdown-icon font-gray font-12 fal"
                [ngClass]="{ 'fa-chevron-down': isInspectionsVisible, 'fa-chevron-up': !isInspectionsVisible }"></i>

              <span class="font-600 font-14">Send&nbsp;inspection</span>
            </div>

            <div class="modal-checkbox" *ngIf="isInspectionsVisible">
              <div *ngFor="let service of order?.services" [hidden]="!service.includeInInvoice" class="mt-1">
                <app-checkbox *ngIf="service?.inspection?.inspectionId" [fontSize]="12"
                  [label]="service?.inspection?.inspectionId?.title" [isChecked]="inspectionsStatus[service?._id]"
                  (appChange)="handleInspectionChange(service?._id, $event)">
                </app-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Right Panel -->
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div class="ui-g-6 p-zero">
      <div class="customer-preview" (click)="preview()">
        <i class="fal fa-copy p-1"></i>
        <span>Customer Preview</span>
      </div>
    </div>

    <div class="ui-g-6 p-zero text-right">
      <input id="send-dialog-btn-cancel" type="button" (click)="close({})" value="Cancel"
        class="btn btn-white btn-border pointer btn-submit mr-1" />

      <button class="btn btn-primary btn-submit" [ngClass]="{ 'btn-secondary': isSent }" [disabled]="isSent"
        (click)="onSubmit()">
        <span [ngClass]="{ 'pr-2': isProcessing, 'not-allowed': isSent }">{{ sendButtonTitle }}</span>
        <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
      </button>
    </div>
  </div>
</div>